// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rJsLaNmgiD05spFZmDGs{display:flex;justify-content:flex-end}`, "",{"version":3,"sources":["webpack://./../features/content-toolbar/src/components/Toolbar/ButtonsGroup.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,wBAAA","sourcesContent":[".buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": `rJsLaNmgiD05spFZmDGs`
};
export default ___CSS_LOADER_EXPORT___;
